import { InvoiceFormType } from "@/types/InvoicesType"

export enum InvoiceFormFields {
  company = "company",
  echeance = "due_date",
  totalReduction = "total_reduction_amount",
  reductionBase = "global_reduction_base",
  reductionType = "global_reduction_type",
  reductionValue = "global_reduction_value",
  tva = "tva_rate",
  grossSubtotal = "gross_subtotal",
  subtotal = "net_subtotal",
  taxAmount = "tax_amount",
  total = "total",
  line_items = "line_items",
  type = "invoice_type",
  description = "description",
  quantity = "quantity",
  unit_price = "unit_price",
  amount = "amount",
  item_reduction = "reduction_value",
}

export const INVOICE_REDUCTION_BASE = {
  "TOTAL": "INVOICE_TOTAL_AMOUNT",
  "PER_LINE": "INVOICE_LINE_ITEM",
}

export const INVOICE_REDUCTION_TYPE = {
  "PERCENTAGE": "PERCENTAGE",
  FIXED: "FIXED",
}

export const INVOICE_DEFAULT_VALUES : InvoiceFormType = {
  // description: '',
  [InvoiceFormFields.company] : '',
  [InvoiceFormFields.echeance] : '',
  [InvoiceFormFields.reductionBase] : INVOICE_REDUCTION_BASE.TOTAL,
  [InvoiceFormFields.reductionType] : INVOICE_REDUCTION_TYPE.PERCENTAGE,
  [InvoiceFormFields.reductionValue] : '0',
  [InvoiceFormFields.tva]: '18.00',
  [InvoiceFormFields.line_items]: [
    {
      [InvoiceFormFields.description]: '',
      [InvoiceFormFields.quantity]: '',
      [InvoiceFormFields.unit_price]: '',
      [InvoiceFormFields.amount]: '0',
      [InvoiceFormFields.item_reduction]: '0'
    }
  ]
}

export enum InvoiceStatusEnum {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  PARTIALLY_PAID = "PARTIALLY_PAID",
  PAID = "PAID",
  OVERDUE = "OVERDUE",
  CANCELLED = "CANCELLED"
}

export enum InvoiceStatusTransEnum {
  DRAFT = "Brouillon",
  PENDING = "En attente de paiement",
  PARTIALLY_PAID = "Partiellement payé",
  PAID = "Payé",
  OVERDUE = "En retard de paiement",
  CANCELLED = "Supprimé"
}

export enum REDUCTIONS_LABEL {
  PER_COLLABO_AND_PERCENT = "Réduction (:p% sur coût par collaborateur)",
  PER_COLLABO_AND_FIXED = "Réduction (sur coût par collaborateur)",
  TOTAL_AND_PERCENT = "Réduction (:p%)",
  TOTAL_AND_FIXED = "Réduction"
}